import { type FunctionComponent } from "preact";
import SiteCookiesTable from "core/SiteCookiesTable";
import EmbedContainer from "core/EmbedContainer";

const SiteCookiesTableEmbed: FunctionComponent = () => {
  return (
    <EmbedContainer>
      {({ scan }) => (
        <SiteCookiesTable
          cookies={scan.cookies}
          updatedAt={scan.cookie_list_updated_at}
        />
      )}
    </EmbedContainer>
  );
};

export default SiteCookiesTableEmbed;
